export default function initLoader() {
    document.body.classList.add("PAGE-IS--LOADED");

    const loader = document.getElementById("app-loader");

    loader.addEventListener(
        "transitionend",
        () => {
            loader.remove();
        },
        { once: true }
    );
}
